@if (entries().length > 0) {
  <span
    class="inventory-warning-notification"
    [appTooltip]="tooltipMessage()"
    tooltipPosition="top"
    tooltipSeverity="warning"
    role="img"
    [attr.aria-label]="'inventoryArticleWarning.tagLabel' | translate"
  >
    <v-one-icon name="warning" [type]="iconType.FILLED" />
    <span class="inventory-warning-notification__label">{{
      'inventoryArticleWarning.tagLabel' | translate
    }}</span>
    <span class="inventory-warning-notification__badge">{{
      entries().length
    }}</span>
  </span>
}
